import * as React from "react";
import type { SVGProps } from "react";
const SvgBullseye = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M29.16 62.198c15.128 0 27.393-12.265 27.393-27.394 0-15.129-12.265-27.393-27.394-27.393-15.129 0-27.393 12.264-27.393 27.393 0 15.13 12.264 27.394 27.393 27.394Zm0 1.75c16.095 0 29.143-13.048 29.143-29.144 0-16.095-13.048-29.143-29.144-29.143C13.064 5.66.016 18.709.016 34.804c0 16.096 13.048 29.144 29.143 29.144Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M29.16 54.622c10.944 0 19.817-8.873 19.817-19.818 0-10.945-8.873-19.817-19.818-19.817-10.944 0-19.817 8.872-19.817 19.817s8.873 19.818 19.817 19.818Zm0-10.492a9.326 9.326 0 1 0 0-18.652 9.326 9.326 0 0 0 0 18.652Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M29.16 52.872c9.978 0 18.067-8.09 18.067-18.068 0-9.978-8.09-18.067-18.068-18.067-9.978 0-18.067 8.089-18.067 18.067 0 9.979 8.089 18.068 18.067 18.068Zm11.075-18.068c0 6.117-4.959 11.076-11.075 11.076-6.118 0-11.076-4.959-11.076-11.076 0-6.117 4.958-11.076 11.076-11.076 6.116 0 11.075 4.96 11.075 11.076Zm8.742 0c0 10.945-8.873 19.818-19.818 19.818-10.944 0-19.817-8.873-19.817-19.818 0-10.945 8.873-19.817 19.817-19.817 10.945 0 19.818 8.872 19.818 19.817Zm-10.492 0a9.326 9.326 0 1 1-18.652 0 9.326 9.326 0 0 1 18.652 0ZM56.69.052l.361 7.94 6.934-.365-5.821 7.069h-7.73v-7.97L56.69.052Zm-4.506 7.366v5.528h5.154l2.769-3.362-4.724.249-.253-5.558-2.946 3.143Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M59.51 5.631c.338.346.332.9-.013 1.238L29.77 35.989a.875.875 0 0 1-1.224-1.25l29.726-29.12a.875.875 0 0 1 1.238.012Z"
      clipRule="evenodd"
    />
    <path fill="#26A3DD" d="M32.158 34.804a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
  </svg>
);
export default SvgBullseye;
